import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "services";
import * as Actions from "actions";
import Common from "us.common";
import { TaskManager } from "constants/Actions";
import { i18n } from "us.helper";
import { $Message } from "us.common/components";
import _, { isArray } from "lodash"; 
import dayjs from "dayjs"
import { DateFormats } from "us.common/constants";

const { $MessageBox } = Common.Components;
const {
  groups,
  pendingTasks,
  tasks,
  newGroup,
  group,
  taskHistory,
  instanceHistory,
  taskInstance,
  operationsHandlers,
  users,
  task,
  email,
  taskRun,
  taskDelete,
  scripts,
} = Actions.taskManager;

const { taskManager } = API;
const {
  GET_GROUPS,
  GET_PENDING_TASKS,
  GET_TASKS,
  CREATE_GROUP,
  UPDATE_GROUP,
  GET_OPERATIONS_HANDLERS,
  GET_USERS,
  GET_TASK_HISTORY,
  GET_INSTANCE_HISTORY,
  DELETE_GROUP,
  SAVE_TASK_INSTANCE,
  CREATE_TASK,
  UPDATE_TASK,
  SEND_EMAIL,
  RUN_TASK,
  DELETE_TASK,
  GET_SCRIPTS,
} = TaskManager;

const TaskManagerSagas = {
  pendingTasks: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.pendingTasks.get,
          params
        );
        if (status === 200) {
          yield put(pendingTasks.success(data));
        } else {
          yield put(pendingTasks.success([]));
        }
      } catch (error) {
        yield put(pendingTasks.fail([]));
      }
    },
  },
  tasks: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.tasks.search, params);
        if (status === 200) {
          yield put(tasks.success(data));
        } else {
          yield put(tasks.success([]));
        }
      } catch (error) {
        yield put(tasks.fail([]));
      }
    },
  },
  groups: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.groups.get, params);
        if (status === 200) {
          yield put(groups.success(data));
        } else {
          yield put(groups.success([]));
        }
      } catch (error) {
        yield put(groups.fail([]));
      }
    },
  },
  group: {
    save: function* (action: any) {
    // save: function* (action: any): Generator<any, void, any> {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.groups.save, params);
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.GROUP_ADDED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(newGroup.success(data));

          if (groups.get) yield put(groups.get({}));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.ADD_GROUP_FAILED`,
            "",
            ""
          );
          yield put(newGroup.fail(data));
        }
      } catch (error) {
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.ADD_GROUP_FAILED`,
          "",
          ""
        );
        yield put(newGroup.fail({}));
      }
    },
    update: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.groups.update, params);
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.GROUP_UPDATED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(group.success(data));

          if (groups.get) yield put(groups.get({}));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.GROUP_UPDATE_FAILED`,
            "",
            ""
          );
          yield put(group.fail({}));
        }
      } catch (error) {
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.GROUP_UPDATE_FAILED`,
          "",
          ""
        );
        yield put(group.fail({}));
      }
    },
    delete: function* (action: any) {
      const params = action?.payload?.data ?? {};
      $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
      try {
        const { deleteData, status } = yield call(
          taskManager.groups.delete,
          params
        );
        if (status === 200) {
          $Message.destroy();
          $MessageBox(
            "success",
            "US.COLLECTION.OPERATIONS:TASK_MANAGER.DELETE_GROUP_SUCCESS",
            "",
            ""
          );
          if (groups.get) yield put(groups.get({}));
        } else {
          $Message.destroy();
          $MessageBox(
            "error",
            "US.COLLECTION.OPERATIONS:TASK_MANAGER.DELETE_GROUP_FAILED",
            "",
            ""
          );
          yield put(groups.fail(new Error()));
        }
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.OPERATIONS:TASK_MANAGER.DELETE_GROUP_FAILED",
          "",
          ""
        );
        yield put(groups.fail(new Error()));
      }
    },
  },
  task: {
    save: function* (action: any) {
    // save: function* (action: any): Generator<any, void, any> {

      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.task.save, params);
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_ADDED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(task.success(data));

          if (tasks.get)
            yield put(
              tasks.get({
                search: "",
                date: dayjs().format(DateFormats.FORMAT_1),
                user: "",
              })
            );
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.ADD_TASK_FAILED`,
            "",
            ""
          );
          yield put(task.fail(data));
        }
      } catch (error) {
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.ADD_TASK_FAILED`,
          "",
          ""
        );
        yield put(task.fail({}));
      }
    },
    update: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.task.save, params);
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_UPDATED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(task.success(data));

          if (tasks.get)
            yield put(
              tasks.get({
                search: "",
                date: dayjs().format(DateFormats.FORMAT_1),
                user: "",
              })
            );
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.UPDATE_TASK_FAILED`,
            "",
            ""
          );
          yield put(task.fail(data));
        }
      } catch (error) {
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.UPDATE_TASK_FAILED`,
          "",
          ""
        );
        yield put(task.fail({}));
      }
    },
    getHistory: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.taskHistory.get,
          params.taskId
        );
        if (status === 200) {
          yield put(taskHistory.success(data));
        } else {
          yield put(taskHistory.success([]));
        }
      } catch (error) {
        yield put(taskHistory.fail([]));
      }
    },
    run: function* (action: any) {
      try {
        $Message.loading(i18n.t("COMMON.RUNNING") as string, 0);
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.task.run,
          params.taskId
        );
        $Message.destroy();
        if (status === 200) {
          const { data: taskData, status } = yield call(
            taskManager.tasks.search,
            {
              search: "",
              date: dayjs().format(DateFormats.FORMAT_1),
              user: "",
            }
          );
          if (status === 200) {
            yield put(tasks.success(taskData));
          }
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_EXECUTED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(taskRun.success(data));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_EXECUTION_FAILED`,
            "",
            ""
          );
          yield put(taskRun.success([]));
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.OPERATION_UPDATE_FAILED`,
          "",
          ""
        );
        yield put(taskRun.fail([]));
      }
    },
    delete: function* (action: any) {
      try {
        $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.task.delete,
          params.taskId
        );
        $Message.destroy();
        if (status === 200) {
          const { data: taskData, status } = yield call(
            taskManager.tasks.search,
            {
              search: "",
              date: dayjs().format(DateFormats.FORMAT_1),
              user: "",
            }
          );
          if (status === 200) {
            yield put(tasks.success(taskData));
          }
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_DELETED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(taskDelete.success(data));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_DELETION_FAILED`,
            "",
            ""
          );
          yield put(taskDelete.success({}));
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.TASK_DELETION_FAILED`,
          "",
          ""
        );
        yield put(taskDelete.fail({}));
      }
    },
  },
  instance: {
    getHistory: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.instanceHistory.get,
          params.taskId
        );
        if (status === 200) {
          yield put(instanceHistory.success(data));
        } else {
          yield put(instanceHistory.success([]));
        }
      } catch (error) {
        yield put(instanceHistory.fail([]));
      }
    },
    // save: function* (action: any) {
    save: function* (action: any): Generator<any, void, any> {   //added Generator with types due eroor
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(
          taskManager.taskInstance.post,
          params
        );
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.OPERATION_UPDATED_SUCCESSFULLY`,
            "",
            ""
          );
          const { data: taskData, status } = yield call(
            taskManager.tasks.search,
            {
              search: "",
              date: dayjs().format(DateFormats.FORMAT_1),
              user: "",
            }
          );
          if (status === 200) {
            yield put(tasks.success(taskData));
          }
          const pendingTasksResponse = yield call(
            taskManager.pendingTasks.get,
            {}
          );
          if (pendingTasksResponse.status === 200) {
            yield put(pendingTasks.success(pendingTasksResponse.data));
          }
          yield put(taskInstance.success(data));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.OPERATION_UPDATE_FAILED`,
            "",
            ""
          );
          yield put(taskInstance.success([]));
        }
      } catch (error) {
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.OPERATION_UPDATE_FAILED`,
          "",
          ""
        );
        yield put(taskInstance.fail([]));
      }
    },
    sendEmail: function* (action: any) {
      try {
        $Message.loading(i18n.t("COMMON.SENDING") as string, 0);
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.email.post, params);
        $Message.destroy();
        if (status === 200) {
          $MessageBox(
            "success",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.EMAIL_DELIVERED_SUCCESSFULLY`,
            "",
            ""
          );
          yield put(email.success(data));
        } else {
          $MessageBox(
            "error",
            `US.COLLECTION.OPERATIONS:TASK_MANAGER.FAILED_TO_DELIVER_THE_EMAIL`,
            "",
            ""
          );
          yield put(email.success([]));
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          `US.COLLECTION.OPERATIONS:TASK_MANAGER.FAILED_TO_DELIVER_THE_EMAIL`,
          "",
          ""
        );
        yield put(email.fail([]));
      }
    },
  },
  operationsHandlers: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.operationsHandlers.get);
        if (status === 200) {
          yield put(operationsHandlers.success(data));
        } else {
          yield put(operationsHandlers.success([]));
        }
      } catch (error) {
        yield put(operationsHandlers.fail([]));
      }
    },
  },
  users: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.users.get);
        if (status === 200) {
          yield put(users.success(data));
        } else {
          yield put(users.success([]));
        }
      } catch (error) {
        yield put(users.fail([]));
      }
    },
  },
  scripts: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(taskManager.scripts.get);
        if (status === 200) {
          yield put(scripts.success(data));
        } else {
          yield put(scripts.success([]));
        }
      } catch (error) {
        yield put(scripts.fail([]));
      }
    },
  },
};

export default [
  takeLatest(GET_PENDING_TASKS, TaskManagerSagas.pendingTasks.get),
  takeLatest(GET_TASKS, TaskManagerSagas.tasks.get),
  takeLatest(GET_GROUPS, TaskManagerSagas.groups.get),
  takeLatest(CREATE_GROUP, TaskManagerSagas.group.save),
  takeLatest(UPDATE_GROUP, TaskManagerSagas.group.update),
  takeLatest(GET_TASK_HISTORY, TaskManagerSagas.task.getHistory),
  takeLatest(GET_INSTANCE_HISTORY, TaskManagerSagas.instance.getHistory),
  takeLatest(SAVE_TASK_INSTANCE, TaskManagerSagas.instance.save),
  takeLatest(GET_OPERATIONS_HANDLERS, TaskManagerSagas.operationsHandlers.get),
  takeLatest(DELETE_GROUP, TaskManagerSagas.group.delete),
  takeLatest(GET_USERS, TaskManagerSagas.users.get),
  takeLatest(CREATE_TASK, TaskManagerSagas.task.save),
  takeLatest(UPDATE_TASK, TaskManagerSagas.task.update),
  takeLatest(SEND_EMAIL, TaskManagerSagas.instance.sendEmail),
  takeLatest(RUN_TASK, TaskManagerSagas.task.run),
  takeLatest(DELETE_TASK, TaskManagerSagas.task.delete),
  takeLatest(GET_SCRIPTS, TaskManagerSagas.scripts.get),
];
